export const groupBy = (items, classifier) => items
  .reduce(
    (acc, item) => (key => ({
      ...acc,
      [key]: [...(acc[key] || []), item],
    }))(classifier instanceof Function ? classifier(item) : item[classifier]),
    {},
  )

export const uniqBy = (items, classifier) => Object.values(groupBy(items, classifier)).map(group => group[0])

export const intersection = (arr1, arr2) => arr1.filter(item => arr2.includes(item))

export const hasIntersection = (arr1, arr2) => intersection(arr1, arr2).length > 0
